<template>
  <!-- 普本专业院校 -->
  <el-button-group>
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加专业院校</el-button
    >
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="PbMajorSchool"
    @update-list="updateList"
    excelName="普本专业院校"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="tableMaxHeight"
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
  >
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>

  <!-- 添加编辑 普本专业院校管理 -->
  <el-dialog
    class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="850px"
  >
    <AddEditpbMajorSchool
      ref="AddEditComponent"
      v-if="addEditVisible"
      :edit-id="editId"
      :is-edit="isEdit"
      :years-sel="yearsSel"
      :category-sel="majorCategorySel"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditpbMajorSchool>
  </el-dialog>

  <!-- 考试教材 -->
  <el-dialog v-model="contentVisible" :title="contentdialogTitle" width="1000px">
    <div  class="contentDialog"
      v-html="contentDetails"
      v-if="contentVisible"
    ></div>
  </el-dialog>
</template>

<script>
import TableList from "components/TableList.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus, getYear } from "common/utils";
import { getMajorPtSchoolList, delSchoolMajor } from "network/pbMajorSchool.js";
import { getMajorCategory } from "network/majorCategory.js";
import AddEditpbMajorSchool from "views/pbMajorSchool/AddEditpbMajorSchool.vue";

export default {
  name: "PbMajorSchool",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditpbMajorSchool,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        }, {
          label: "专业名称",
          prop: "name",
          width: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "所属年份",
          prop: "year",
          width: "160",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "所属专业类别",
          prop: "majorCategoryName",
          width: "160",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "针对院校",
          prop: "schoolName",
          width: "160",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch",
        },
        {
          label: "原计划招生人数",
          prop: "initialEnrolment",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "调整后招生人数",
          prop: "adjustEnrolment",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "建档立卡考生人数",
          prop: "inputtingCard",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "录取分数",
          prop: "score",
          width: "140",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "考试科目",
          prop: "majorCourses",
          width: "300",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "考试教材",
          prop: "majorSubject",
          width: "140",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
        },
      ],
      //筛选项
      search: {
        name: null, //筛选 院校名称
        year: null, //筛选 年份
        schoolName: null, //针对院校
        majorCategoryId: null, //筛选 专业类别
      },
      yearsSel: [], //年份下拉选项
      majorCategorySel: [], //专业类别下拉选项
      dialogTitle: "添加普本专业院校",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //编辑id
      isEdit: false, //是否是编辑
      contentdialogTitle: "",
      contentVisible: false, //内容弹窗
      contentDetails: "", //内容
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getMajorCategoryList(); //获取专业类别
      getPbMarjorSchool(); //请求普本专业院校列表数据
      // 获取年份下拉框
      data.yearsSel = getYear(16);
      data.headerData.map((item) => {
        if (item.prop == "year") {
          item.selectOptions = data.yearsSel;
        }
      });
    });

    //获取专业类别下拉 普本专业类别 IsPtzsb传true
    function getMajorCategoryList() {
      getMajorCategory(true)
        .then((res) => {
          if (res.code == 1) {
            data.majorCategorySel = res.result;
            data.headerData.map((item) => {
              if (item.prop == "majorCategoryName") {
                item.selectOptions = data.majorCategorySel;
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // 获取列表
    const getPbMarjorSchool = () => {
      data.loading = true;
      const obj = {
        name: data.search.name || null,
        year: data.search.year || null,
        schoolName: data.search.schoolName || null,
        majorCategoryId: data.search.majorCategoryId || null,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getMajorPtSchoolList(obj)
        .then((result) => {
          
          if (result && result.code == 1) {
            const list = result.result.rows;
            data.pagination.total = result.result.totalCount;
            const dataList = toRaw(list);
            data.tableData = dataList;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "year") {
        data.search.year = val.value;
      }
      if (val.prop && val.prop == "schoolName") {
        data.search.schoolName = val.value;
      }
      if (val.prop && val.prop == "majorCategoryName") {
        data.search.majorCategoryId = val.value;
      }
      data.pagination.currentPage = 1;
      getPbMarjorSchool();
    };

    //更新列表
    const updateList = () => {
      getPbMarjorSchool();
    };
    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 添加
    const addFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加专业院校";
      data.editId = 0;
      data.isEdit = false;
    };
    // 编辑
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.name}】专业院校`;
      data.editId = obj.id;
      data.isEdit = true;
    };

    // 删除
    const deleteFnc = (obj) => {
      ElMessageBox.confirm(`是否删除[${obj.name}]专业院校？`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteData(obj.id);
        })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      delSchoolMajor(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    // 打开考试教材弹窗
    const openContent = (val) => {
      if (val.prop == "majorSubject") {
        data.contentdialogTitle = `查看【${val.value.name}】考试教材`;
        data.contentVisible = true;
        data.contentDetails = val.value.majorSubject;
      }
    };

    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getPbMarjorSchool,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      openContent,
      AddEditComponent,
      handleClose,
    };
  },
};
</script>
<style scoped>
</style>

